<template>
    <div>
        <div class="entry-info_item">
            <span class="label small-caps">Internal Notes:</span>
            <div class="value internal-text-value" v-if="!WysiwygOpen"><span v-html="originalInternalNote"></span> <a href="#" @click.prevent="WysiwygOpen = !WysiwygOpen" v-text="editOrAdd"></a></div>
        </div>
        <note-editor v-if="WysiwygOpen" :actionurl="actionurl" :internal_note_loaded="originalInternalNote" @closeModal="closeModalUpdateData"></note-editor>
    </div>
</template>

<script>
    import 'jodit/build/jodit.min.css'
    import { JoditVue } from 'jodit-vue'
    import NoteEditor from "./NoteEditor";

    export default {
        components: {NoteEditor, JoditVue },
        props: ['actionurl', 'internal_note_loaded'],
        data() {
            return {
                buttons: ['bold', 'underline', 'italic', 'eraser', 'ul', 'ol', 'link'],
                editOrAdd: 'Add',
                WysiwygOpen: false,
                originalInternalNote: '',
            }
        },
        created: function() {
            this.originalInternalNote = this.internal_note_loaded;
            if(this.originalInternalNote.length > 0) {
                this.editOrAdd = 'Edit';
            }
        },
        watch: {
            WysiwygOpen: function (val) {
                if (val) {
                    this.editOrAdd = 'Close';
                } else {
                    if (this.originalInternalNote.length > 0) {
                        this.editOrAdd = 'Edit';
                    } else {
                        this.editOrAdd = 'Add';
                    }
                }
            },
        },
        methods: {
            closeModalUpdateData: function(updatedText) {
                this.originalInternalNote = updatedText;
                this.WysiwygOpen = false;
            }
        },
    }
</script>
